// Shared "expected error" predicates for the COA account/fund save flows.
// An expected error is one the user can fix (validation, reconciliation
// guardrails) — the form surfaces field feedback but does NOT report it to
// Sentry. Unexpected errors (infra/logic failures) fall through to capture.
//
// Extracted from InlineAccountForm/InlineFundForm so the legacy modal forms
// (add_account.jsx / add_fund.jsx) share the exact same filter.

export const isExpectedAccountError = (error) => {
  const msg = error?.message?.toLowerCase() || "";
  return [
    "completed reconciliations",
    "cleared in a bank reconciliation",
    "fund starting balances must equal",
    "starting balance date must be before",
    "date is required",
  ].some((pattern) => msg.includes(pattern));
};

export const isExpectedFundError = (error) => {
  const msg = error?.message?.toLowerCase() || "";
  return [
    "fund name is required",
    "fund number is required",
    "fund number must start with",
    "fund group is required",
    "sub-fund must have a parent",
  ].some((pattern) => msg.includes(pattern));
};
